import { Box, Button, Card, Modal, Typography } from "@mui/material";
import { icons } from "../../assets/icons/icons";
import { colors } from "../../values/colors";
import CustomInput from "../CustomInput";

const InputModal = ({
  open,
  onClose,
  onConfirm,
  title,
  reason,
  setReason,
  placeholder,
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card
        sx={{
          width: 400,
          px: 3,
          py: 6,
          borderRadius: "16px",
          boxShadow: "0px 4px 25px rgba(0,0,0,0.15)",
          textAlign: "center",
        }}
      >
        <img src={icons.warn} alt="warn" />
        <Typography
          sx={{ fontSize: "1.5rem", fontWeight: "600", mt: "3rem", mb: "1rem" }}
        >
          {title}
        </Typography>
        <CustomInput
          placeholder={placeholder}
          value={reason}
          setValue={setReason}
          required
        />
        <Box
          sx={{
            mt: 3,
            display: "flex",
            justifyContent: "center",
            gap: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={onClose}
            sx={{
              backgroundColor: "#1E1E1E",
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              py: ".4rem",
              fontSize: "1rem",
              width: "120px",
              "&:hover": { backgroundColor: "#000" },
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{
              background: colors.linearGradent,
              color: "#fff",
              textTransform: "none",
              borderRadius: "999px",
              width: "120px",
            }}
          >
            Confirm
          </Button>
        </Box>
      </Card>
    </Modal>
  );
};

export default InputModal;
